import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsDatesRoute: InvariantJiraRoute = {
	name: 'polaris-settings-financial-year',
	path: '/jira/settings/products/jira-product-discovery/dates',
	exact: true,
};
